import React from 'react';
import { FaFacebook, FaInstagram, FaYoutube } from 'react-icons/fa';

function Header() {
  return (
    <header className="header">
      <div className="logo">
        <img src="/logo.png" alt="Bramble Farm Logo" className="header-logo" />
        <div className="title">
          <h1>Bramble Farm</h1>
          <p>Dalton, PA</p>
        </div>
      </div>
      <div className="header-right">
        <div className="contact">
          <p>(570) 798-3098</p>
        </div>
        <div className="social-icons">
          <a href="https://www.facebook.com/bramblefarmtherapy" target="_blank" rel="noopener noreferrer">
            <FaFacebook />
          </a>
          <a href="https://www.youtube.com/@bramblefarm" target="_blank" rel="noopener noreferrer">
            <FaYoutube />
          </a>
           <a href="https://www.instagram.com/bramblefarmtherapy" target="_blank" rel="noopener noreferrer">
            <FaInstagram />
          </a>
        </div>
      </div>
    </header>
  );
}

export default Header;